import React from 'react';
import Modal2 from '../../Modal2';
import { ThemeSetup } from '../../../themes/ThemeSetup';
import t from '../../../i18n/I18n';
import { Img } from '../../../common/elements';
import { Button } from '../../../common';
import './CollectionModalV2.css';

const CollectionModalV2 = ({ name, icon, title, onClose, children, okBtnText, footer = undefined, onOk, noFooter = false }) => {
  const closeModalIcon = ThemeSetup.getImageURL('collections/cross-icon.svg');
  const renderHeader = (
    <div className="new-modal-header flex-row spc-between">
      <div className="new-modal-title-wrapper flex-row">
        {icon && <img src={icon} alt="" srcset="" />}
        <div className="new-modal-title">{title}</div>
      </div>
      <Img onClick={onClose} src={closeModalIcon} className="new-modal-close-icon"></Img>
    </div>
  );

  const renderFooter = noFooter ? null : (footer ? footer : (
    <div className="new-modal-footer flex-row justify-end">
      <Button onClick={onClose} className="new-modal-cancel new-modal-btn" text={t('CANCEL_LABEL')} type="CANCEL" labelClass={"cancelBtn"} />
      <Button onClick={onOk} className="new-modal-confirm new-modal-btn" text={okBtnText} type="PRIMARY" labelClass={"submitBtn"} />
    </div>
  ));

  return (
    <Modal2 name={name} onClose={onClose} header={renderHeader} footer={renderFooter} noFooter={noFooter} closeOnOutsideClick={false}>
      {children}
    </Modal2>
  );
};

export default CollectionModalV2;
